export const invoiceUmrahTags = [
  'invoices',
  'InvoiceUmrah',
  'NewInvoiceUmrah',
  'EditInvoiceUmrah',
];
export const INVOICE_UMRAH = 'InvoiceUmrah';
